import SvgIcon from "@material-ui/core/SvgIcon";

const DashboardIcon = (props) => (
  <SvgIcon
    {...props}
    component="svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path d="M21 13a9 9 0 11-9-9v9l7-5 2 5z" />
    <path d="M13 11V1c2 1 6 2 7 4l-7 6z" />
  </SvgIcon>
);

export default DashboardIcon;
